export const navLinks = [
    {
        id: 0,
        name: 'ABOUT US',
        url: '/about-us',
    },
    {
        id: 2,
        name: 'PATIENT RESOURCES',
        url: '/patient-resources',
    },
    {
        id: 3,
        name: 'SERVICES',
        url: '/outpatient',
        dropdown: [
            { id: 0, name: 'ENT', url: '/surgical/ear-nose-and-throat' },
            { id: 1, name: 'GASTROENTEROLOGY', url: '/surgical/gastroenterology-surgery/' },
            { id: 2, name: 'NEUROSURGERY', url: '/surgical/neurosurgery/' },
            {
                id: 3,
                name: 'GYNECOLOGY',
                url: '/surgical/gynecology/',
            },
            { id: 4, name: 'ORTHOPEDIC', url: '/surgical/orthopedic/' },
            {
                id: 5,
                name: 'PAIN MANAGEMENT',
                url: '/surgical/pain-management/',
            },
            { id: 6, name: 'PLASTIC SURGERY', url: '/surgical/plastic-reconstructive' },
            { id: 7, name: 'PODIATRIC', url: '/surgical/podiatric/' },
            { id: 8, name: 'ERECTILE DYSFUNCTION', url: '/surgical/erectile-dysfunction/' },
            { id: 9, name: 'HAIR RESTORATION', url: '/aesthetics/neograft-hair-restoration/' },
        ],
    },
    {
        id: 4,
        name: 'CLIENT PORTAL',
        url: 'https://www.myaestheticspro.com/clientportal/dsp_loginportal.cfm?AE8224C6C9C47DBB820C4BC6F5B1B12A',
    },
    {
        id: 5,
        name: 'CONTACT US',
        url: '/contact',
    },
];
